export const AUTH_SESSION_STORAGE_KEY = 'session-id';
